export default __webpack_public_path__ + "static/media/Biotechnology.d26e0434.pdf";